import { DateTimePicker } from '@mui/x-date-pickers';

import { styled } from '../styled';
import { Colors } from '../theme';

export const DatePickerStyled = styled(DateTimePicker)(({ theme }) => ({
  '.MuiInputAdornment-root': {
    marginLeft: 0,
    marginRight: 8,
  },
  '.MuiIconButton-root': {
    padding: 4,
    transition: theme.transitions.create('color'),

    '&:hover': {
      color: Colors.hover,
    },
  },
  '.clearButton': {
    color: Colors.black,
  },
}));
